export const SAVE_ROOM = 'ADD_USER';
export const REMOVE_ROOM = 'REMOVE_ROOM';

export function saveRoomData (roomId) {
  return {
    type: SAVE_ROOM,
    roomId
  }
}

export function removeRoomData () {
  return {
    type: REMOVE_ROOM,
    roomId: null
  }
}